import React, { useState } from "react";
import { ChevronDown, Eye, FileText } from "lucide-react";

const Row = ({ label, children, className = "" }) => (
  <div className={`mt-2 text-sm ${className}`}>
    <span className="font-medium text-gray-500">{label}:</span>{" "}
    <span className="break-words text-gray-800">{children}</span>
  </div>
);

export default function MobClientArticles({
  documents = [],
  onViewDocument, 
  onViewJournals, 
  onViewDetails, 
}) {
  const [openId, setOpenId] = useState(null);

  if (!documents || documents.length === 0) {
    return (
      <p className="rounded-md border border-[#d3cccc] bg-white py-8 text-center text-sm text-gray-500">
        No data found
      </p>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
      {documents.map((doc) => {
        const isOpen = openId === doc.id;
        const toggle = () => setOpenId(isOpen ? null : doc.id);

        return (
          <div
            key={doc.id}
            onClick={toggle}
            className="relative h-full cursor-pointer rounded-md border border-[#d3cccc] bg-white p-4 pb-16 shadow-sm transition active:scale-[0.98]"
          >
            {/* Always visible */}
            <Row label="Project ID" className="!mt-0">
              {doc.projectId ?? "-"}
            </Row>

            <div className="mt-2 text-sm">
              <span className="font-medium text-gray-500">Title:</span>{" "}
              <span
                className="line-clamp-2 break-words text-gray-800"
                title="Click to view full title and abstract"
                onClick={(e) => {
                  e.stopPropagation();
                  onViewDetails?.(doc, "title");
                }}
              >
                {doc.title ?? "-"}
              </span>
            </div>

            <Row label="Date">{doc.uploadDate ?? "-"}</Row>

            {/* Expanded details */}
            {isOpen && (
              <div className="mt-3 border-t border-dashed border-gray-200 pt-1">
                <div className="mt-2 text-sm">
                  <span className="font-medium text-gray-500">Abstract:</span>{" "}
                  <span
                    className="line-clamp-6 break-words text-gray-800"
                    title="Click to view full title and abstract"
                    onClick={(e) => {
                      e.stopPropagation();
                      onViewDetails?.(doc, "abstract");
                    }}
                  >
                    {doc.abstract ?? "-"}
                  </span>
                </div>
              </div>
            )}

            {/* Bottom-left actions */}
            <div className="absolute bottom-3 left-3 flex gap-3">
              <button
                type="button"
                title="View document"
                aria-label="View document"
                className="rounded-full bg-blue-600 p-2 text-white hover:bg-blue-700"
                onClick={(e) => {
                  e.stopPropagation();
                  onViewDocument?.(doc);
                }}
              >
                <FileText className="h-4 w-4" />
              </button>

              <button
                type="button"
                title="View journals"
                aria-label="View journals"
                className="rounded-full border border-green-400 bg-green-100 p-2 text-green-700 hover:bg-green-200"
                onClick={(e) => {
                  e.stopPropagation();
                  onViewJournals?.(doc);
                }}
              >
                <Eye className="h-4 w-4" />
              </button>
            </div>

            {/* Bottom-right expand icon */}
            <button
              type="button"
              aria-label={isOpen ? "Show less" : "Show more"}
              className="absolute bottom-3 right-3 rounded-full p-1 text-gray-600 hover:bg-gray-100"
              onClick={(e) => {
                e.stopPropagation();
                toggle();
              }}
            >
              <ChevronDown
                className={`h-5 w-5 transition-transform ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </button>
          </div>
        );
      })}
    </div>
  );
}